export class AdminBookEditorListRequest {
  page: number = 1;
  pageSize: number = 100;
  search: string | null = null;
  status: string | null = null;
  dateStart: string | null = null;
  dateEnd: string | null = null;
}

export class AdminBookEditorSaveRequest {
  idBookVersion: number = 0;
  bookTitle: string | null = null;
  coverAuthorName: string | null = null;
  bookSubtitle: string | null = null;
  versionName: string | null = null;
  collectionName: string | null = null;
  volumeName: string | null = null;
  synopsis: string | null = null;
  preface: string | null = null;
  backCoverText: string | null = null;
  isbn: string | null = null;
  doi: string | null = null;
  idPrimaryCategory: number | null = null;
  idSecondaryCategory: number | null = null;
  idPhotoShape: number | null = null;
  bookEstimatedPages: number | null = null;
  totalPages: number | null = null;
  idBookPrint: number | null = null;
  idStatusVersion: number | null = null;
  idUserAuthor: number | null = null;
  listAuthors: string[] = [];
  authorName: string | null = null;
  authorBio: string | null = null;
  authorPhotoFileName: string | null = null;
  frontCoverFileName: string | null = null;
  backCoverFileName: string | null = null;
  coverForPrintFileName: string | null = null;
  bookForPrintFileName: string | null = null;
  bookForEbookFileName: string | null = null;
  saleCoverFileName: string | null = null;
  kits: AdminBookEditorKitSaveRequest[] = [];
}

export class AdminBookEditorKitSaveRequest {
  idKit: number = 0;
  kitName: string | null = null;
  kitDescription: string | null = null;
  totalPrice: number = 10;
  includesBook: boolean = false;
  includesEbook: boolean = false;
  includesVideoAccess: boolean = false;
  isActive: boolean = true;
}

/** Liga/desliga "Liberado para marketplace". */
export class AdminBookEditorMarketplaceToggleRequest {
  idBookVersion: number = 0;
  enabled: boolean = false;
}

/** Reenvia para publicação anúncio que ficou com erro (idMarketplace null = todos). */
export class AdminBookEditorMarketplaceReprocessRequest {
  idBookVersion: number = 0;
  idMarketplace: number | null = null;
}
